import React from 'react';
import { Script } from 'gatsby';

const GATSBY_GOOGLE_TAG = process.env.GATSBY_GOOGLE_TAG;

export default function GatsbyGoogleTag() {
  //console.debug('GatsbyGoogleTag', GATSBY_GOOGLE_TAG);
  return (
    (GATSBY_GOOGLE_TAG ?
      <>
        <Script id={'gtag-config'}>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GATSBY_GOOGLE_TAG}');
          `}
        </Script>
      </>
    :
      null
    )
  )
}
